import { render, staticRenderFns } from "./product-category.vue?vue&type=template&id=59d12bde&scoped=true&"
import script from "./product-category.vue?vue&type=script&lang=js&"
export * from "./product-category.vue?vue&type=script&lang=js&"
import style0 from "./product-category.vue?vue&type=style&index=0&id=59d12bde&lang=scss&scoped=true&"
import style1 from "./product-category.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d12bde",
  null
  
)

export default component.exports